<script setup lang="ts">
const message = 'Hello Vue!';
</script>

<template>
  <div id="app">
    <p class="text-center text-lg">{{ message }}</p>
  </div>
</template>
